module.exports = __webpack_public_path__ + "img/opensea.17733597.png";